module.exports = __webpack_public_path__ + "./fonts/Nunito-Semibold.ttf";